(function (angular) {
  'use strict';

  try {
    angular.module('risevision.common.config');
  } catch (err) {
    angular.module('risevision.common.config', []);
  }

  angular.module('risevision.common.components.userstate', [
      'ui.router',
      'ui.router.state.events',
      'risevision.common.components.logging',
      'risevision.common.components.loading',
      'risevision.common.components.scrolling-list',
      'risevision.common.config',
      'risevision.common.gapi',
      'risevision.core.util'
    ])

    .config(['$urlServiceProvider',
      function($urlService) {
        $urlService.deferIntercept();
      }
    ])

    // Set up our mappings between URLs, templates, and controllers
    .config(['$urlRouterProvider', '$urlMatcherFactoryProvider', '$locationProvider',
      function storeRouteConfig($urlRouterProvider, $urlMatcherFactoryProvider,
        $locationProvider) {

        $locationProvider.html5Mode(true);
        $locationProvider.hashPrefix('/');

        $urlRouterProvider
          .when(function(url) {
            return url.hash && url.hash.match(/.*(jwt_token)=.*/);
          }, ['$state', 'customAuthFactory', 'userAuthFactory',
            function ($state, customAuthFactory, userAuthFactory) {
              console.log('SSO result received');
              var tokens = window.location.hash.split('&');
              var token1 = tokens[0].split('=')[1];
              var token2 = tokens[1].split('=')[1];
              var userInfo = {
                item: token1
              };

              return customAuthFactory._updateToken(token2, userInfo)
              .then(function() {
                  userAuthFactory.setLoginMethod('SSO');
                  return userAuthFactory.authenticate(true);
                })
                .then(function () {
                  window.location.hash = '';
                })
                .catch(function (e) {
                  return $state.go(
                    'apps.auth.unauthorized',
                    { authError: e }
                  );
                });
            }
          ])
          .when(function(url) {
            return url.hash && url.hash.match(/.*(error|error_description)=.*/);
          }, ['$state',
            function ($state) {
              console.log('SSO result received');
              var tokens = window.location.hash.split('&');
              var token1 = tokens[0].split('=')[1];
              var token2 = tokens[1].split('=')[1];

              return $state.go(
                'apps.auth.unauthorized',
                {
                  authError: {
                    code: token1,
                    message: decodeURIComponent(token2),
                    type: 'sso_error'
                  },
                  replace: true
                }
              );
            }
          ])
          .when(/\/.*(id_token|access_token)=.*/, ['$window', 'userAuthFactory', 'openidConnect',
            function ($window, userAuthFactory, openidConnect) {
              console.log('Google Auth result received 1');

              var location = $window.location.href;
              location = location.replace('#/', '#');

              openidConnect.signinRedirectCallback(location)
                .then(function (user) {
                  $window.location.hash = '';

                  userAuthFactory.setLoginMethod('Google');
                  return userAuthFactory.authenticate(true);
                })
                .catch(function () {
                  $window.location.hash = '';
                });
            }
          ])
          .when(function(url) {
            return url.hash && url.hash.match(/.*(id_token|access_token)=.*/);
          }, ['$state', 'userAuthFactory', 'openidConnect',
            function ($state, userAuthFactory, openidConnect) {
              console.log('Google Auth result received 2');

              openidConnect.signinRedirectCallback()
                .then(function (user) {
                  userAuthFactory.setLoginMethod('Google');
                  return userAuthFactory.authenticate(true);
                })
                .then(function () {
                  window.location.hash = '';
                })
                .catch(function (e) {

                  return $state.go(
                    'apps.auth.unauthorized',
                    {
                      authError: e
                    }
                  );
                });
            }
          ])
          .when(/\/resetpassword\/.+\/.+/, ['$location', '$state',
            function($location, $state) {
              var parts = $location.absUrl().split('/');
              var token = parts[parts.length - 1];
              var user = parts[parts.length - 2];
              $state.go('apps.auth.resetpassword', { user: user, token: token });
            }
          ])
          .otherwise('/');

        // https://stackoverflow.com/questions/24420578/handling-trailing-slashes-in-angularui-router
        $urlMatcherFactoryProvider.strictMode(false);
      }
    ])

    .run(['$rootScope', '$state', '$stateParams', 'urlStateService',
      'userState', 'userAuthFactory', '$loading', '$transitions', 'canAccessApps',
      function ($rootScope, $state, $stateParams, urlStateService,
        userState, userAuthFactory, $loading, $transitions, canAccessApps) {

        $loading.startGlobal('auth-buttons-silent');
        userAuthFactory.authenticate(false).finally(() => {
          $loading.stopGlobal('auth-buttons-silent');
        });

        $rootScope.$on('$stateChangeStart', function (event, toState,
          toParams, fromState, fromParams) {
          if (toState && (
              toState.name === 'apps.auth.unauthorized' ||
              toState.name === 'apps.auth.unregistered' ||
              toState.name === 'apps.auth.createaccount') && !toParams.state) {

            if (fromParams.state) {
              $state.params.state = fromParams.state;

              event.preventDefault();

              $state.go(toState.name, $state.params);
            }
          }
        });

        $rootScope.$on('risevision.user.signedOut', function () {
          $state.go('apps.auth.unauthorized');
        });

        $transitions.onBefore({
          to: state => state.data && state.data.requiresAuth
        }, () => canAccessApps());

        $rootScope.$on('risevision.user.authorized', function () {
          var currentState = $state.current.name;

          if (currentState.indexOf('apps.auth') !== -1 && currentState !== 'apps.auth.unsubscribe') {
            if (currentState === 'apps.auth.unregistered' && !userState.isRiseVisionUser())  {
              return;
            }

            urlStateService.redirectToState($stateParams.state);
          }
        });
      }
    ]);

})(angular);
